import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import type { InvestorCommunicationStatus } from "@entrilia/shared/api/investorCommunicationsTypes";
import InvestorCommunicationStatusTag from "@entrilia/shared/components/InvestorCommunicationStatusTag";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import type { InvestorCommunicationCategory } from "../../api/types/investorCommunicationsTypes";
import { impersonationSelector } from "../../store/state/user/selectors";
import NewsCategoryTag from "./NewsCategoryTag";

interface Props {
  publishedAt: string | undefined;
  categories: InvestorCommunicationCategory[];
  status: InvestorCommunicationStatus;
}

const NewsItemMeta = ({ publishedAt, categories, status }: Props) => {
  const isImpersonation = useSelector(impersonationSelector);

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
      {isImpersonation && <InvestorCommunicationStatusTag status={status} />}
      <Typography variant="caption" color="textSecondary">
        {convertISODate(publishedAt)}
      </Typography>
      {categories.map((category) => (
        <NewsCategoryTag key={category.externalId} category={category} />
      ))}
    </Stack>
  );
};

export default NewsItemMeta;
